// Currently returns if value is in the plus size Set.

import { plusSizes } from '../constants/productSizes';

// Eventually this can be extended to be based on field name (e.g. size_top)
export function getIsPlusSizeByField(selectedOption, fieldName) {
  return plusSizes.has(selectedOption.value);
}
